var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(['apeiron_uat', 'apeiron'].includes(_vm.$store.state.tenantId))?_c('apeiron-product-create',_vm._b({},'apeiron-product-create',_vm.payload,false)):_c('default-product-create')],1)}
var staticRenderFns = []

export { render, staticRenderFns }